<template>
  <div class="subscription-app bg-secondary min-h-screen">
    <nav class="border-subtle flex w-full items-center border-b p-5 bg-surface-raised">
      <div class="flex items-center">
        <img class="h-6" :src="tredcoLogo" alt="Tredco">
      </div>
    </nav>
    <!-- The hosted Stripe table and the invoice form are retired: a package
         is chosen in the app, under «Abonnement». Native builds from before
         the removal no longer open this page. -->
    <main class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8 text-center">
      <h1 class="text-heading-2 text-color-label-1">
        {{ $t('subscription.site.title') }}
      </h1>
      <p class="mt-2 text-label-2 text-color-label-2">
        {{ $t('subscription.site.body') }}
      </p>
      <a class="tredco-button tredco-button--primary mt-6" href="https://tredco.app/settings">
        {{ $t('subscription.site.open_app') }}
      </a>
    </main>
  </div>
</template>

<script setup lang="ts">
import tredcoLogo from "../../public/brand/v2/tredco-horizontal.svg"
</script>
